import { render } from "./BpmnDeleteConnectionDialog.vue?vue&type=template&id=e013eb98"
import script from "./BpmnDeleteConnectionDialog.vue?vue&type=script&lang=js"
export * from "./BpmnDeleteConnectionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__